import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';

const DownloadEmployeeExcelButton = ({
    buildFilters
}) => {

    const handleDownload = async () => {

        try {

            const token =
                localStorage.getItem("token");

            const filters = buildFilters();

            const queryParams =
                new URLSearchParams(filters);

            const response = await fetch(

                `${process.env.REACT_APP_API_URL}/employees/download-excel?${queryParams.toString()}`,

                {
                    method: "GET",

                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }

            );

            if (!response.ok) {

                throw new Error(
                    "Failed to download"
                );

            }

            const blob =
                await response.blob();

            const url =
                window.URL.createObjectURL(blob);

            const a =
                document.createElement("a");

            a.href = url;

            a.download =
                "Employee_Report.xlsx";

            document.body.appendChild(a);

            a.click();

            a.remove();

            window.URL.revokeObjectURL(url);

        }

        catch (error) {

            console.error(error);

            alert(
                "Failed to download excel"
            );

        }

    };

    return (

        <button
            className="download-btn"
            onClick={handleDownload}
            title="Download Excel"
        >
            <FontAwesomeIcon icon={faFileExcel} />
        </button>
    );

};

export default DownloadEmployeeExcelButton;